import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { User } from '../models/user';
// import { Staff } from '../models/staff';

@Injectable({
  providedIn: 'root'
})
export class UserDataService {
  private UserDataSubject = new BehaviorSubject<User | null>(null);
  public currentUserData = this.UserDataSubject.asObservable();

  constructor() {}
  changeUserData(userData: any): void {
    this.UserDataSubject.next(userData);
  }
}
